export default __webpack_public_path__ + "static/media/@milton.neto_.88db65a0.PNG";